<template>
    <div>
        <div class="row py-3">
            <div class="col-md-3">
                <el-button
                    type="primary"
                    class="btn btn-primary"
                    @click="showModal()"
                    >Crear alerta</el-button
                >
            </div>
        </div>
        <div>
            <section v-if="!initialLoading">
                <div class="row">
                    <div class="col-12">
                        <div class="table-responsive">
                            <table
                                id="data-list-alerts"
                                class="table-hover-animation table-striped table-bordered"
                            >
                                <thead>
                                    <tr>
                                        <th>Título</th>
                                        <th>Fecha de finalización</th>
                                        <th>Estado</th>
                                        <th>Acción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="alert in alerts" :key="alert.id">
                                        <td>{{ alert.title }}</td>
                                        <td>{{ alert.deadline }}</td>

                                        <td v-if="alert.status"><el-tag size="small" type="success">Activo</el-tag></td>
                                        <td v-else><el-tag size="small" type="info">Inactivo</el-tag></td>
                                        
                                        <!-- <td>
                                            <div class="text-center">
                                                <button
                                                    class="btn btn-primary"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#exampleModal"
                                                    @click="
                                                        this.selected = cliente
                                                    "
                                                >
                                                    Editar
                                                </button>
                                            </div>
                                        </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
            <custom-spinner v-else></custom-spinner>
        </div>

        <!-- modal -->
        <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel">
                            Crear alerta
                        </h1>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <form
                            @submit.prevent="submit"
                            id="upload"
                            method="post"
                        >
                            <div class="row">
                                <div class="mb-3 col-12">
                                    <label for="" class="form-label"
                                        >Título:
                                    </label>
                                    <input
                                        type="text"
                                        v-model="form.title"
                                        class="form-control"
                                        placeholder="Ingrese el título"
                                    />
                                </div>
                                <div class="mb-3 col-12">
                                    <label for="" class="form-label"
                                        >Descripción:
                                    </label>
                                    <input
                                        type="text"
                                        v-model="form.description"
                                        class="form-control"
                                        placeholder="Ingrese la descripción"
                                    />
                                </div>

                                <div class="mb-3 col-12">
                                    <label for="" class="form-label"
                                        >Fecha de finalización:
                                    </label>
                                    <el-date-picker
                                        class="ml-3"
                                        v-model="form.deadline"
                                        type="datetime"
                                        format="YYYY/MM/DD HH:mm:ss"
                                        value-format="YYYY/MM/DD HH:mm:ss"
                                        placeholder="Fecha de finalización"
                                    />
                                </div>

                                <div class="mb-3 col-12">
                                    <label for="" class="form-label"
                                        >Enlace de redirección:
                                    </label>
                                    <input
                                        type="text"
                                        v-model="form.link"
                                        class="form-control"
                                        placeholder="Ingrese el enlace"
                                    />
                                </div>
                                <div class="text-center">
                                    <button
                                        type="button"
                                        @click="submit"
                                        class="btn btn-primary"
                                    >
                                        Guardar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import ModalComponent from "../ModalComponent.vue";
import CustomSpinner from "../../common/custom-spinner/CustomSpinner.vue";
import language from "../../api/traduction_es";

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: {},
            initialLoading: false,
            moment: moment,
            alerts: [],
            selected: [],
        };
    },
    components: {
        "custom-modal": ModalComponent,
        "custom-spinner": CustomSpinner,
    },

    mounted() {
        this.listAlerts();
    },

    methods: {
        showModal() {
            $("#exampleModal").modal("show");
        },

        async submit() {
            const { data } = axios.post("/alerts/store", this.form);
            console.log(data);
        },
        loadDataTable() {
            $(document).ready(function () {
                $("#data-list-alerts").DataTable(language);
            });
        },

        listAlerts: async function () {
            this.initialLoading = true;
            const { data } = await axios.get(`/alerts/list`);
            this.alerts = data;
            this.initialLoading = false;
            this.loadDataTable();
        },
    },
};
</script>
<style>
.el-select {
    width: 80%;
}
.el-select .el-input .el-select__caret::before {
    content: "\e794";
}

#customize_select {
    background-color: #ffffff !important;
    border: none !important;
    width: 0px !important;
    font-size: 0px !important;
    justify-content: center;
    text-align: center;
    padding: 0 !important;
}
</style>
